import { Controller } from "@hotwired/stimulus"

// Portal Service Catalog search.
// Client-side filtering — no server round-trip needed since items are
// preloaded in the page. Debounces text input for smooth UX.
//
// CONEK-8261: the catalog is category first, so the page only ever holds ONE
// category's services and this search is scoped to them; the root-category
// filter pills (and their state) went with that change.
//
// data-controller="support--catalog-search"
export default class extends Controller {
  static targets = ["input", "empty", "item", "group"]

  connect() {
    this._timeout = null
  }

  disconnect() {
    if (this._timeout) clearTimeout(this._timeout)
  }

  search() {
    if (this._timeout) clearTimeout(this._timeout)
    this._timeout = setTimeout(() => this._applyFilters(), 200)
  }

  clear() {
    if (this.hasInputTarget) this.inputTarget.value = ""
    this._applyFilters()
  }

  _applyFilters() {
    const query = this.hasInputTarget
      ? this.inputTarget.value.trim().toLowerCase()
      : ""
    let visibleCount = 0

    this.itemTargets.forEach((item) => {
      const name = (item.dataset.name || "").toLowerCase()
      const desc = (item.dataset.description || "").toLowerCase()

      const visible = !query || name.includes(query) || desc.includes(query)
      item.classList.toggle("hidden", !visible)
      if (visible) visibleCount++
    })

    // Sub-category listing fix: a category group owns a heading, so hiding only its cards
    // left the title behind ("Access & Permissions" over empty space) once a
    // search excluded everything inside it. Hide the group when it has no
    // visible card left.
    this.groupTargets.forEach((group) => {
      const hasVisibleItem = Array.from(
        group.querySelectorAll('[data-support--catalog-search-target="item"]'),
      ).some((item) => !item.classList.contains("hidden"))
      group.classList.toggle("hidden", !hasVisibleItem)
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.classList.toggle("hidden", visibleCount > 0)
    }
  }
}
